import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { format } from "date-fns";
import { it } from "date-fns/locale";

const wall = (iso) => format(new Date(iso), "yyyy-MM-dd'T'HH:mm:ss");
const put = (e, patch) => (e.riunione_id
  ? api.put(`/riunioni/${e.riunione_id}`, { ...patch, ...(patch.data ? { data: patch.data.slice(0, 16) } : {}) })
  : api.put(`/appuntamenti/${e.id}`, patch));

// Sposta/ridimensiona subito; toast con "Annulla" per 5 secondi.
export async function aggiornaConAnnulla(e, patch, reload) {
  const prima = { data: wall(e.data), durata_min: e.durata_min || 60 };
  try { await put(e, patch); } catch (err) { toast.error(apiError(err)); return; }
  reload();
  const msg = patch.data ? `Spostato a ${format(new Date(patch.data), "EEE d MMM 'alle' HH:mm", { locale: it })}${(e.partecipanti_ids || []).length || e.riunione_id ? " · partecipanti avvisati" : ""}` : `Durata: ${patch.durata_min} minuti`;
  toast.success(msg, {
    duration: 5000,
    action: { label: "Annulla", onClick: async () => {
      try { await put(e, patch.data ? { data: prima.data } : { durata_min: prima.durata_min }); toast.success("Modifica annullata"); reload(); }
      catch (err) { toast.error(apiError(err)); }
    } },
  });
}
